import { observer } from "mobx-react-lite";
import React from "react";
import { Table } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import { formatCurrency } from "../../../app/common/util/functions";
import { InventoryCurrentValueDto } from "../../../app/models/inventoryReports";

interface Props {
  allValues: InventoryCurrentValueDto[];
  groupedValues: [string, InventoryCurrentValueDto[]][];
  calculateTotals: (data: InventoryCurrentValueDto[]) => number;
}

export default observer(function InventoryCurrentValuePrintDetailed({
  calculateTotals,
  groupedValues,
  allValues,
}: Props) {
  const { t } = useTranslation(["common", "reports"]);

  return (
    <>
      {groupedValues.map(([group, items], groupIndex) => (
        <React.Fragment key={groupIndex}>
          <>
            <Table.Body>
              <Table.Row>
                <Table.Cell
                  colSpan={16}
                  textAlign="left"
                  className="terms_bold"
                >
                  {group}
                </Table.Cell>
              </Table.Row>
            </Table.Body>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>
                  {t("part_number", { ns: "reports" })}
                </Table.HeaderCell>
                <Table.HeaderCell>
                  {t("description", { ns: "common" })}
                </Table.HeaderCell>
                <Table.HeaderCell>
                  {t("location", { ns: "common" })}
                </Table.HeaderCell>
                <Table.HeaderCell textAlign="right">
                  {t("pops.qty", { ns: "tickets" })}
                </Table.HeaderCell>
                <Table.HeaderCell textAlign="right">
                  {t("avg_cost", { ns: "reports" })}
                </Table.HeaderCell>
                <Table.HeaderCell textAlign="right">
                  {t("value", { ns: "reports" })}
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {items.map((item: InventoryCurrentValueDto, itemIdx: number) => (
                <Table.Row key={itemIdx}>
                  <Table.Cell
                    data-label={`${t("part_number", { ns: "reports" })}:`}
                  >
                    {item.partNumber}
                  </Table.Cell>
                  <Table.Cell
                    data-label={`${t("description", { ns: "common" })}:`}
                  >
                    {item.partDescription}
                  </Table.Cell>
                  <Table.Cell
                    data-label={`${t("location", { ns: "common" })}:`}
                  >
                    {item.location}
                  </Table.Cell>
                  <Table.Cell
                    data-label={`${t("pops.qty", { ns: "tickets" })}:`}
                    textAlign="right"
                  >
                    {item.quantity}
                  </Table.Cell>
                  <Table.Cell
                    textAlign="right"
                    data-label={`${t("avg_cost", { ns: "reports" })}:`}
                  >
                    {formatCurrency(item.averageCost)}
                  </Table.Cell>
                  <Table.Cell
                    data-label={`${t("value", { ns: "reports" })}:`}
                    textAlign="right"
                  >
                    {formatCurrency(item.value)}
                  </Table.Cell>
                </Table.Row>
              ))}

              <Table.Row className="terms_bold">
                <Table.Cell>{t("total", { ns: "common" })}</Table.Cell>
                <Table.Cell textAlign="right"></Table.Cell>
                <Table.Cell textAlign="right"></Table.Cell>
                <Table.Cell textAlign="right"></Table.Cell>
                <Table.Cell textAlign="right"></Table.Cell>
                <Table.Cell
                  textAlign="right"
                  data-label={`${t("cost", { ns: "reports" })}:`}
                >
                  {formatCurrency(calculateTotals(items))}
                </Table.Cell>
              </Table.Row>
              <Table.Row className="noBackground">
                <Table.Cell colSpan={11}></Table.Cell>
              </Table.Row>
            </Table.Body>
          </>
        </React.Fragment>
      ))}
      <Table.Row className="terms_bold greenRow">
        <Table.Cell>{t("grandTotals", { ns: "reports" })}</Table.Cell>
        <Table.Cell textAlign="right"></Table.Cell>
        <Table.Cell textAlign="right"></Table.Cell>
        <Table.Cell textAlign="right"></Table.Cell>
        <Table.Cell textAlign="right"></Table.Cell>
        <Table.Cell
          textAlign="right"
          data-label={`${t("cost", { ns: "reports" })}:`}
        >
          {formatCurrency(calculateTotals(allValues))}
        </Table.Cell>
      </Table.Row>
    </>
  );
});
